import { apiUrl } from '../constants/apiConsts';
import fetchRequest from '../utils/request';
import { getHeaders } from './helpers';

class HomeHubApi {
  static getHomeHub() {

    const request = new Request(`${apiUrl}/content/home_hub`, {
      method: 'GET',
      headers: getHeaders(),
    });

    return fetchRequest(request);
  }

    static getHomeHubImage(imageId) {
      const request = new Request(`${apiUrl}/content/image/${imageId}`, {
        method: 'GET',
        headers: getHeaders(),
      });
  
      return fetchRequest(request);
    }
}

export default HomeHubApi;
